// src/components/DesktopLayout.js
import {
  Box,
  useTheme,
} from '@mui/material';
import DesktopHeader from './DesktopHeader';
import Footer from './Footer';

const DesktopLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <div style={{ direction: 'rtl' }}>
      {/* Make DesktopHeader sticky */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: theme.zIndex.appBar,
        }}
      >
        <DesktopHeader />
      </Box>

      <Box component="main" sx={{ py: 3, minHeight: '80vh' }}>
        {children}
      </Box>
      
      <Footer />
    </div>
  );
};

export default DesktopLayout;
